import React from "react";
import Axios from "axios";

// components
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PrivateRoute, AuthProvider } from "./auth";
import { View } from "components/lib";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./mui-theme";

// 404
import { NotFound } from "views/error/404";

// tailwind css
import "../css/output.css";

// settings
const Settings = require("settings.json");
const StripePromise = loadStripe(
  Settings[process.env.NODE_ENV].stripe.publishableAPIKey
);

const routes = [
  ...require("routes/setup").default,
  ...require("routes/account").default,
  ...require("routes/app").default,
  ...require("routes/auth").default,
  ...require("routes/website").default,
];

export default function App(props) {
  const user = JSON.parse(localStorage.getItem("user"));
  Axios.defaults.baseURL = Settings[process.env.NODE_ENV].server_url;

  if (user?.token) {
    // add auth token to api header calls
    Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
  }

  // render the routes
  // Stripe Elements render in an iframe that cannot read our self-hosted
  // fonts, so Roboto is passed in as a hosted stylesheet for card fields only.
  const stripeOptions = {
    fonts: [
      {
        cssSrc:
          "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap",
      },
    ],
  };

  return (
    <ThemeProvider theme={theme}>
      <Elements stripe={StripePromise} options={stripeOptions}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {routes.map((route) => {
                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      route.permission ? (
                        <PrivateRoute permission={route.permission}>
                          <View
                            display={route.view}
                            layout={route.layout}
                            title={route.title}
                            skin={route.skin}
                          />
                        </PrivateRoute>
                      ) : (
                        <View
                          display={route.view}
                          layout={route.layout}
                          title={route.title}
                          skin={route.skin}
                        />
                      )
                    }
                  />
                );
              })}

              {/* 404 */}
              <Route
                path="*"
                element={
                  <View display={NotFound} layout="home" title="404 Not Found" />
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </Elements>
    </ThemeProvider>
  );
}
